// extracted by mini-css-extract-plugin
export default {"button-wrapper":"user_button-wrapper__9s+pl","search-input":"user_search-input__cu4hx","submit-button":"user_submit-button__o+2l7"};